import { useEffect, useState } from 'react';
import DeleteIcon from "src/assets/all-icons/delete-icon.jsx";

import config from '@/config';
import FixedCharInput from '@/shared-components/inputs/components/FixedCharInput';
import Loader from '@/shared-components/loader/Loader';

import './BoardBodyPicture.css';

export default function InlinePostImage({
  groupId, 
  image,
  onRemove,
  onCaptionChange,
  previewMode = false,
  isEmbeddedBlock = true,
}) {
  const [isEditing, setIsEditing] = useState(false);

  const [caption, setCaption] = useState(image.picture_description || '');

  useEffect(() => {
    setCaption(image.picture_description || '');
  }, [image.picture_description]);

  const previewCaption = image.picture_description?.trim() || '';
  const isUploading = image.status === 'uploading';

  const handleCaptionChange = (e) => {
    const newCaption = e.target.value;
    setCaption(newCaption);
  };

  const saveCaption = () => {
    onCaptionChange?.(groupId, image.pictureId, caption);
    setIsEditing(false);
  };

  const imageUrl = image.image_id
    ? `${config.app.imageServiceDomain}/${image.image_id}/w=2000`
    : null;

  return (
    <div className={`post-image-with-caption${isEmbeddedBlock ? ' post-embedded-block' : ''}`}>
      <div className="post-image-inline-container">
        {/* remove button only in edit */}
        {!previewMode && (
          <DeleteIcon
            className="post-image-inline-remove-button"
            onClick={onRemove}
          />
        )}
        <div className="image-wrapper">
          {isUploading ? (
            <div className="post-image-inline__loading" role="status" aria-label="Image is loading">
              <Loader inline thin />
            </div>
          ) : (
            <img
              src={imageUrl}
              srcSet={`${config.app.imageServiceDomain}/${image.image_id}/w=200 200w,
                   ${config.app.imageServiceDomain}/${image.image_id}/w=400 400w,
                   ${config.app.imageServiceDomain}/${image.image_id}/w=600 600w,
                   ${config.app.imageServiceDomain}/${image.image_id}/w=800 800w,
                   ${config.app.imageServiceDomain}/${image.image_id}/w=1000 1000w,
                   ${config.app.imageServiceDomain}/${image.image_id}/w=1200 1200w,
                   ${config.app.imageServiceDomain}/${image.image_id}/w=1400 1400w,
                   ${config.app.imageServiceDomain}/${image.image_id}/w=1600 1600w,
                   ${config.app.imageServiceDomain}/${image.image_id}/w=1800 1800w,
                   ${config.app.imageServiceDomain}/${image.image_id}/w=2000 2000w,
                   ${config.app.imageServiceDomain}/${image.image_id}/w=2200 2200w`
              }
              alt="Uploaded post"
              className="post-image-inline"
            />
          )}
        </div>
      </div>

      {isUploading ? null : previewMode ? (
        previewCaption ? (
          <p className="post-image-inline-caption-preview">
            {previewCaption}
          </p>
        ) : null
      ) : (
        // in edit toggle between “Add description” and the editor
        !isEditing ? (
          <p
            className="post-image-inline-caption-add"
            contentEditable={false}
            onClick={() => {
              setIsEditing(true);
            }}
          >
            {caption || 'Add description'}
          </p>
        ) : (
          <div className="post-image-inline-caption-editor" contentEditable={false}>
            <DeleteIcon
              className="post-image-inline-caption-header-remove"
              onClick={saveCaption}
            />
            <FixedCharInput
              element={`post_picture_description_${image.image_id}`}
              label="Description"
              maxChar={200}
              value={caption}
              onChange={handleCaptionChange}
              onBlur={saveCaption}
            />
          </div>
        )
      )}
    </div>
  );
}
